import { clsx } from 'clsx';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'ghost' | 'danger';
type Size = 'sm' | 'md' | 'icon';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  label: string;
  children: ReactNode;
}

const variants: Record<Variant, string> = {
  primary: 'bg-accent-500 hover:bg-accent-400 text-navy-950',
  ghost: 'bg-white/5 hover:bg-white/10 text-slate-200',
  danger: 'bg-red-500/15 hover:bg-red-500/25 text-red-300',
};

const sizes: Record<Size, string> = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  icon: 'h-9 w-9',
};

export function IconButton({
  variant = 'ghost',
  size = 'icon',
  label,
  children,
  className,
  ...props
}: IconButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      className={clsx(
        'inline-flex items-center justify-center rounded-lg transition-colors disabled:opacity-40 disabled:pointer-events-none',
        variants[variant],
        sizes[size],
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
